module.exports = __webpack_public_path__ + "static/land-rover-series-3-galvanised-chassis-side-5a2c11a07c909b5175356419ebce2d1c.jpg";